import { render, staticRenderFns } from "./FeatureEdit.vue?vue&type=template&id=74038684"
import script from "./FeatureEdit.vue?vue&type=script&lang=js"
export * from "./FeatureEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports